import React from 'react';
import { SegmentedControl as SegmentedControlNew } from './SegmentedControl';
import { convertOldSegmentedControlProps } from './converter.old';
import type { OldSegmentedControlOptionType, OldSegmentedControlProps } from './converter.old';
import type { SegmentedControlInstance } from './SegmentedControl';

export type SegmentedControlOptionType = OldSegmentedControlOptionType;
export type SegmentedControlProps = OldSegmentedControlProps;

export const SegmentedControl = React.forwardRef<SegmentedControlInstance, SegmentedControlProps>((props, ref) => (
  <SegmentedControlNew {...convertOldSegmentedControlProps(props)} ref={ref} />
));
